import React from 'react';
import Lottie from 'react-lottie-player';
import INSTAPOINT_LOTTIE from './instapoint-lottie.json';
import PropTypes from 'prop-types';
import { LeftDiv, RightDiv, Container, Box, Header } from './index.style';
import { connect } from 'react-redux';
import { DEVICE_MOBILE } from '../../../utils/constants';
import { CommonButton } from '@Components';
import { CHECK_BLUE_ICON, NEW_INSTAREM_LOGO_ICON } from '@Images';

const InstapointDashboard = (props) => {
  const handlePopUpClose = () => {
    return props.onClose(true);
  };

  const { acknowledgement_instapoint, transaction_referral_instapoint } =
    props.instaPointsLogicData || {};
  const isMobile = props.device === DEVICE_MOBILE;
  const { instapoints, min_source_amount_limit } = props.instapoint_balance || {};
  return (
    <>
      <Header>
        <h1 title="InstaRem" className="brand-logo-wrapper">
          <a
            href="#!"
            onClick={(e) => {
              e.preventDefault();
            }}
            title="InstaRem"
            target="_blank"
          >
            <img src={NEW_INSTAREM_LOGO_ICON} alt="instarem-logo" className="brand-logo" />
          </a>
        </h1>
      </Header>
      <Container isMobile={isMobile}>
        <LeftDiv isMobile={isMobile}>
          <div className="header">
            <div>You earned</div>
            <div>{instapoints} InstaPoints!</div>
          </div>
          <div className="sub-content">
            <div>100 InstaPoints give you a</div>
            <div>
              {props.value} {props.source_currency} discount
            </div>
            <div>
              when you transfer over {min_source_amount_limit} {props.source_currency}
            </div>
          </div>
          <Lottie
            loop={false}
            play={true}
            animationData={INSTAPOINT_LOTTIE}
            style={{ position: 'absolute', top: '-100px', marginLeft: isMobile ? '0px' : '-86px' }}
          />
        </LeftDiv>
        <RightDiv isMobile={isMobile}>
          <Box isActive={true}>
            <div id="instapoints-section-1">
              <div className="insta-number" id="instapoints-section-1-number">
                +{instapoints}
              </div>
              <div className="insta-text">InstaPoints</div>
            </div>
            <div id="instapoints-section-1-text">Register an account</div>
            <img src={CHECK_BLUE_ICON} alt="check" />
          </Box>
          <Box>
            <div id="instapoints-section-2">
              <div className="insta-number" id="instapoints-section-2-number">
                +{acknowledgement_instapoint}
              </div>
              <div className="insta-text">InstaPoints</div>
            </div>
            <div id="instapoints-section-2-text">Verify account in 36 hours</div>
          </Box>
          <Box>
            <div id="instapoints-section-3">
              <div className="insta-number" id="instapoints-section-3-number">
                +{transaction_referral_instapoint}
              </div>
              <div className="insta-text">InstaPoints</div>
            </div>
            <div id="instapoints-section-3-text">For each friend you refer</div>
          </Box>
        </RightDiv>
        <div className="button-container-onboarding-screen proceed">
          <CommonButton text="Proceed" id="instapoint-submit-btn" onClick={handlePopUpClose} />
        </div>
      </Container>
    </>
  );
};

InstapointDashboard.propTypes = {
  instaPointsLogicData: PropTypes.object,
  onClose: PropTypes.func,
  device: PropTypes.string,
  source_currency: PropTypes.string,
  value: PropTypes.number,
  isSplitKYCFlow: PropTypes.bool,
  instapoint_balance: PropTypes.object
};

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      userDataReducer: { instaPointsLogicData },
      uiTriggerState: { device },
      userSessionReducer: { instapoint_balance }
    }
  } = reduxState;

  return { instaPointsLogicData, device, instapoint_balance };
}

export default connect(mapStateToProps)(InstapointDashboard);
